import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme as useMuiTheme } from '@mui/material/styles';

import MDInput from 'components/MDInput';
import { FieldCard } from '../ui/FieldCard';

export function HealthNotesCard({ form, set }) {
  const theme = useMuiTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <FieldCard
      icon="healing"
      tone="amber"
      title="Sağlık / Not"
      subtitle="Önemli durumları kısaca yaz"
    >
      <MDInput
        label="Hastalık, sakatlık, önemli notlar"
        value={form.notes}
        onChange={(e) => set('notes', e.target.value)}
        multiline
        rows={isMobile ? 6 : 5}
        placeholder="Örn: bel fıtığı, diz ağrısı, hamilelik, doktor uyarısı..."
      />
    </FieldCard>
  );
}
